import * as React from "react";
import { ViewLarge, Viewport, ViewSmall } from "bernie-view";
import {
  callToActionButtons,
  heartButton,
} from "components/flexComponents/DestinationHero/components/DestinationHeroButtons";
import { DestinationHeroViewProps } from "components/flexComponents/DestinationHero/typings";
import { UitkLayoutFlex } from "uitk-react-layout-flex";

export const DestinationHeroHeading = (props: DestinationHeroViewProps) => {
  const { flexComponent, context } = props;
  const { model } = flexComponent;
  const { content, flightsLink, hotelsLink } = model;
  if (!content?.title) {
    return null;
  }
  const { title, subTitle } = content;
  const { id, name, type } = context?.searchContext?.location;

  return (
    <Viewport>
      <ViewSmall>
        <UitkLayoutFlex className="DestinationHeroGalleryTitle all-y-padding-four" justifyContent="space-between">
          <h1 className="uitk-flex uitk-flex-column all-b-margin-one uitk-type-display-800">
            {pageHeading(title, subTitle)}
          </h1>
          {heartButton(id, name, String(type))}
        </UitkLayoutFlex>
      </ViewSmall>

      <ViewLarge>
        <UitkLayoutFlex className="SimpleContainer all-y-padding-three" justifyContent="space-between">
          <UitkLayoutFlex className="DestinationHeroGalleryTitle large-icon">
            <h1 className="uitk-type-display-900 uitk-flex uitk-flex-column all-b-margin-one">
              {pageHeading(title, subTitle)}
            </h1>
            {heartButton(id, name, String(type))}
          </UitkLayoutFlex>
          {callToActionButtons(hotelsLink, flightsLink, props.analytics)}
        </UitkLayoutFlex>
      </ViewLarge>
    </Viewport>
  );
};

const pageHeading = (title: string, subTitle?: string) => (
  <>
    <span>{title}</span>
    {subTitle && <span className="uitk-type-400 uitk-type-regular all-t-margin-one">{subTitle}</span>}
  </>
);
